import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IDashboardFilters } from '@app/shared/common/customizable-dashboard/models/IDashboardFilters';

@Injectable()
export class DashboardOrderService {
    constructor(private router: Router) {
    }

    public navigate(filter: IDashboardFilters) {
        // if (orderNumbers.length === 0) {
        //     return;
        // }

        let queryParams = {
            dashboardViewFilter: true,
            xFilter: filter.xFilter,
            yFilter: filter.yFilter,
            zFilter: filter.zFilter
        };

        this.router.navigate(['app/main/shipments/orders'], {
            queryParams: queryParams
        });
    }
}
